/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
import { Injectable } from '@angular/core';
import { SystemService } from '../../service/system.service';
import { HttpClient} from '@angular/common/http';


@Injectable()
export class homedashService {
url: any = '';
    systemService: SystemService;

    constructor(private http: HttpClient) {
        this.systemService = new SystemService();
        this.url = this.systemService.getAppUrl();
    }
    getHomeData() {
        const url = `${this.url}home/dashboard`;
        return this.http.get(url)
            .toPromise()
            .then(response => {
                if (response) {
                    //   this.dashboardObj = response.json();
                    // return JSON.stringify(response);
                    return response;
                }
                // return this.dashboardObj;
            })
            .catch(reason => {
                console.error(reason);
                // return reason;
            })
    }
}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/homeDash/homedash.service.ts